import React from 'react';

function NotFound() {

    return (
        <p>Ahh Yikes! That page does not exist (yet?)</p>
    );
}

export default NotFound;